<template>
    <div>
      <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'caseIndex'
  }
</script>

<style scoped>

</style>
